import {
  RedoClientProvider,
  WidgetClientProvider,
} from "@redotech/redo-web/client";
import { IpifyGeoClientProvider } from "@redotech/redo-web/ipify";
import { ExtensionShopifyClient } from "@redotech/shopify-client/ajax";
import { ReactNode } from "react";
import { ExtensionShopifyClientContext } from "./shopify";

export const RedoRoot = ({
  children,
  extensionShopifyClient,
  widgetId,
}: {
  children: ReactNode;
  extensionShopifyClient: ExtensionShopifyClient | undefined;
  widgetId: string;
}) => {
  if (extensionShopifyClient) {
    children = (
      <ExtensionShopifyClientContext.Provider value={extensionShopifyClient}>
        {children}
      </ExtensionShopifyClientContext.Provider>
    );
  }

  return (
    <IpifyGeoClientProvider apiKey={process.env.IPIFY_API_KEY!}>
      <RedoClientProvider url={process.env.REDO_API_URL!}>
        <WidgetClientProvider widgetId={widgetId}>
          {children}
        </WidgetClientProvider>
      </RedoClientProvider>
    </IpifyGeoClientProvider>
  );
};
